// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeClabeReference(incomingPayment: PendingIncomingPayment): string {
  const clabeReference = incomingPayment['clabe_reference'];
  if (!clabeReference)
    throw new Error('Spei: Invalid state - There is no clabe_reference property for this payment');

  return clabeReference;
}
